export const defaultSorted = [{ dataField: "id", order: "desc" }];
export const initialFilter = {
  searchKey: "",
  sortOrder: "desc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 20,
  isFeatured: "",
  isEcom: "",
};

export const BRAND_LOCAL_STORAGE_KEYS = {
  searchFilter: "brand_search_filter",
  exportStatus: "BEstatus",
  exportTaskId: "BEid",
};

export const BRAND_SEARCH_FILTER_STORAGE_KEY = BRAND_LOCAL_STORAGE_KEYS.searchFilter;
export const BRAND_EXPORT_STATUS_STORAGE_KEY = BRAND_LOCAL_STORAGE_KEYS.exportStatus;
export const BRAND_EXPORT_TASK_ID_STORAGE_KEY = BRAND_LOCAL_STORAGE_KEYS.exportTaskId;
export const BRAND_EXPORT_TASK_EMPTY_VALUE = "null";

export const brandFilterInitialValues = {
  searchText: "",
  isFeatured: "",
  isEcom: "",
};

export const hasBrandFilterValue = (value) => value !== "" && value !== undefined && value !== null;

const normalizeBooleanFilterValue = (value) => {
  if ([true, "true", 1, "1"].includes(value)) return true;
  if ([false, "false", 0, "0"].includes(value)) return false;
  return "";
};

export const normalizeBrandFilterValues = (values = {}) => ({
  searchText: values.searchText || "",
  isFeatured: normalizeBooleanFilterValue(values.isFeatured),
  isEcom: normalizeBooleanFilterValue(values.isEcom),
});

export const getSavedBrandSearchFilter = () => {
  try {
    if (typeof localStorage === "undefined") return null;

    const savedFilter = JSON.parse(localStorage.getItem(BRAND_SEARCH_FILTER_STORAGE_KEY));
    if (!savedFilter || typeof savedFilter !== "object") return null;

    return {
      advance_filters: normalizeBrandFilterValues(savedFilter.advance_filters),
      show_advance_filters: Boolean(savedFilter.show_advance_filters),
    };
  } catch (error) {
    return null;
  }
};

export const persistBrandSearchFilter = (values, showAdvanceFilters = false) => {
  const nextSavedFilter = {
    advance_filters: normalizeBrandFilterValues(values),
    show_advance_filters: Boolean(showAdvanceFilters),
  };

  if (typeof localStorage !== "undefined") {
    localStorage.setItem(BRAND_SEARCH_FILTER_STORAGE_KEY, JSON.stringify(nextSavedFilter));
  }

  return nextSavedFilter;
};

export const prepareBrandFilterQueryParams = (queryParams, values) => {
  const normalizedValues = normalizeBrandFilterValues(values);
  return {
    ...queryParams,
    searchKey: encodeURIComponent(normalizedValues.searchText),
    isFeatured: normalizedValues.isFeatured,
    isEcom: normalizedValues.isEcom,
  };
};

export const getInitialBrandQueryParams = () => {
  const savedFilter = getSavedBrandSearchFilter();
  if (!savedFilter?.advance_filters) return initialFilter;

  return prepareBrandFilterQueryParams(initialFilter, savedFilter.advance_filters);
};
